import React, { useContext, useState} from 'react'
import {Card, CardBody, CardFooter, Row, Col, Button, ButtonGroup} from 'reactstrap'
import icon from '../../assets/img/icons/flodesk-icon.svg'
import {Context as AuthContext} from '../../context/AuthContext'

export default function FlodeskConnection() {
  const authContext = useContext(AuthContext);
  const { flodesk_accounts } = authContext.state;
  const { deleteFlodeskConnection, createFlodeskConnection  } = authContext;

  const handleDelete = () => {
    const id = flodesk_accounts[0]?.id;
    deleteFlodeskConnection(id)
  }

  return (
    <Card>
      <CardBody className="text-center">
        <div className="card-avatar avatar avatar-lg mx-auto">
          <img src={icon} alt="Flodesk Connection" className="avatar-img rounded"/>
        </div>
        <h2 className="mb-3">Flodesk</h2>
      </CardBody>
      <CardFooter className="card-footer-boxed">
        {flodesk_accounts.length === 0 &&
          <Row className="align-items-center justify-content-between">
            <div className="col-auto">
              <span className="text-secondary">●</span> Not Connect
            </div>
            <div className="col-auto">
              <Button name="connect" size="sm" color="primary" onClick={createFlodeskConnection}>Connect</Button>
            </div>
          </Row>
        }
        {flodesk_accounts.length > 0 &&
          <Row className="align-items-center justify-content-between">
            <div className="col-auto">
              <span className="text-success">●</span> Connected
            </div>
            <div className="col-auto">
              <Button name="delete" size="sm" color="secondary" onClick={handleDelete}>Delete</Button>
            </div>
          </Row>
        }
      </CardFooter>
    </Card>
  )
}
